// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__37d5C","actionsCol":"EnrolledClinics_actionsCol__2RUFv"};